<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
    transition="slide-x-reverse-transition"
  >
    <v-layout class="layout-default-modal" v-if="!expanded">
      <v-flex xs7></v-flex>
      <v-flex xs5 class="flex-default-modal" >
        <v-icon class="close-default-modal" right color="#27DABC" @click="$emit('close-dialog')">close</v-icon>
          <slot></slot>
        </v-flex>
    </v-layout>
    <v-layout class="layout-default-modal" v-if="expanded">
      <v-flex hidden-md-and-down lg3></v-flex>
      <v-flex md12 lg9 class="flex-default-modal" >
        <v-icon class="close-default-modal" right color="#27DABC" @click="$emit('close-dialog')">close</v-icon>
        <slot></slot>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>

<script>
export default {
  name: 'DefaultRightModal',
  props: {
    dialog: {
      type: Boolean
    },
    expanded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.close-color:hover{ 
  color: #27DABC;
}
.layout-default-modal {
  background: rgba(6, 35, 59, 0.18);
  color: white;
  min-height: 100%;
  position: relative;
}
.flex-default-modal {
  background: #06233B !important;
  min-height: 100%;
  min-width: 500px;
}
.close-default-modal {
  position: absolute;
  right: 30px;
  top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultRightModal.vue